import { Controller } from "@hotwired/stimulus"

// 選考フォームの求人選択を「企業で絞り込み → 求人を選ぶ」の2段階にする。
// 企業セレクトは絞り込み専用（フォーム送信されない）。求人セレクト(job_id)が保存対象の真実源。
// 各求人 <option> の data-company-id を見て、選ばれた企業の求人だけを表示する。
//
// 使い方:
//   <div data-controller="company-job-filter">
//     <select data-company-job-filter-target="company"
//             data-action="change->company-job-filter#companyChanged">...</select>
//     <div data-controller="searchable-select">
//       <select data-company-job-filter-target="job">
//         <option value="1" data-company-id="3">…</option>
//       </select>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["company", "job"]

  connect() {
    // 初期表示（編集時に企業が選択済みなら、その企業の求人だけを表示する）。
    this.applyFilter()
  }

  // 企業を切り替えたら、選択中の求人をリセットしてから絞り込む。
  companyChanged() {
    this.jobTarget.value = ""
    this.applyFilter()
  }

  // 選択中の企業に一致する求人 <option> だけを表示し、他は隠す。
  // 企業未選択（空）なら全求人を表示する。
  applyFilter() {
    const companyId = this.companyTarget.value
    Array.from(this.jobTarget.options).forEach((option) => {
      if (option.value === "") return // prompt（先頭の空 option）は常に残す
      const match = !companyId || option.dataset.companyId === companyId
      option.hidden = !match
      option.disabled = !match
    })
    // 検索コンボボックス（searchable-select）に候補の再構築を促す。
    this.jobTarget.dispatchEvent(new CustomEvent("searchable-select:refresh", { bubbles: true }))
  }
}
